import { css } from '@betterment/samba-styled-system/css';

import { Icon } from './icon';
import { LinkButton } from './link-button';
import { Logo } from './logo';
import { Separator } from './separator';
import { Subtext } from './subtext';
import { Text } from './text';

import type { SystemStyleObject } from '@betterment/samba-styled-system/types';

type Props = {
  id?: string;
  css?: SystemStyleObject;
  children: React.ReactNode;
};

export function NavComponent(props: Props) {
  const { children, css: cssProp, id } = props;
  const className = css(
    {
      '& > *': {
        paddingLeft: 'space.150',
        paddingRight: 'space.150',
      },
      px: 'space.100',
      backgroundColor: 'primitives.navy.100',
      _light: {
        backgroundColor: 'primitives.navy.100',
      },
      _dark: {
        backgroundColor: 'background.surface',
        md: {
          borderRightStyle: 'solid',
          borderRightWidth: 'thin',
          borderRightColor: 'border',
        },
      },
    },
    cssProp
  );
  return (
    <nav id={id} className={className}>
      {children}
    </nav>
  );
}

export const Nav = Object.assign(NavComponent, {
  Icon,
  LinkButton,
  Logo,
  Separator,
  Subtext,
  Text,
});
